// extracted by mini-css-extract-plugin
module.exports = {"camFeedbackButton":"CamFeedbackModal_camFeedbackButton__oJys7","modal":"CamFeedbackModal_modal__9bC3O","modalContent":"CamFeedbackModal_modalContent__6hQmQ"};